import moment from 'moment';
import 'moment-timezone';
import store from '../store';

function resolveDisplayTimezone() {
	try {
		const state = store.getState();
		const app = state?.app;
		const country_zone = app?.app_configs?.business_configs;
		const business_id = app?.owner_id;
		const fromConfig = country_zone?.[business_id]?.business_timezone;
		if (fromConfig) {
			return fromConfig;
		}

		const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		if (systemTz && systemTz !== 'UTC') return systemTz;

		if (typeof moment.tz?.guess === 'function') {
			const guessed = moment.tz.guess();
			if (guessed) return guessed;
		}
		return 'Asia/Kolkata';
	} catch (error) {
		return 'Asia/Kolkata';
	}
}

export const convertUTCToTimezone = (utcDate, format = 'YYYY-MM-DD HH:mm:ss',is_format = true) => {
	if (!utcDate) return '';
	const tz = resolveDisplayTimezone();
	if (is_format)
		return moment.utc(utcDate).tz(tz).format(format);
	return moment.utc(utcDate).tz(tz);
};

export const toUTCFromTimezone = (localDate, inputFormat = 'YYYY-MM-DD HH:mm:ss') => {
	if (!localDate) return '';
	const tz = resolveDisplayTimezone();
	return moment.tz(localDate, inputFormat, tz).utc().toISOString();
};

export const defaultUTCFromTimezone = (start_day = false, country_zone = 'Asia/Kolkata') => {
	const tz = country_zone;
	if (start_day) return moment.tz(tz).startOf('day').toISOString();
	else return moment.tz(tz).add(1, 'day').startOf('day').toISOString();
};
